import React, { useCallback, useRef, useState } from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import Form, { ButtonItem, ButtonOptions, CustomRule, Item, Label, RequiredRule } from 'devextreme-react/form';
import LoadIndicator from 'devextreme-react/load-indicator';
import notify from 'devextreme/ui/notify';
import { changePassword } from '../../../api/auth';
import './ChangePasswordForm.scss';
import { useAuth } from "../../../contexts/auth";

export default function ChangePasswordForm() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const formData = useRef({ password: '', confirmPassword: '' });
  const { token } = useParams();
  const { user } = useAuth();

  const onSubmit = useCallback(async (e: any) => {
    e.preventDefault();
    const { password } = formData.current;
    setLoading(true);
    const result = await changePassword(token as string, password);
    setLoading(false);
    if (result.isOk) {
      navigate('/login');
      notify('Password has been updated', 'success', 2500);
    } else {
      notify(result.message, 'error', 2000);
    }
  }, [navigate, token]);

  const confirmPassword = useCallback(
    ({ value }: any) => value === formData.current.password,
    []
  );

  return (
    <form className={'new-password-form'} onSubmit={onSubmit}>
      <Form formData={formData.current} disabled={loading} requiredMark={""}>
        <Item
          dataField={'password'}
          editorType={'dxTextBox'}
          editorOptions={passwordEditorOptions}
        >
          <RequiredRule message="Password is required" />
          <Label visible={false} />
        </Item>
        <Item
          dataField={'confirmPassword'}
          editorType={'dxTextBox'}
          editorOptions={confirmPasswordEditorOptions}
        >
          <RequiredRule message="Password is required" />
          <CustomRule
            message={'Passwords do not match'}
            validationCallback={confirmPassword}
          />
          <Label visible={false} />
        </Item>
        <ButtonItem>
          <ButtonOptions
            elementAttr={submitButtonAttributes}
            width={'100%'}
            type={'default'}
            useSubmitBehavior={true}
          >
            <span className="dx-button-text">
              {
                loading
                  ? <LoadIndicator width={'24px'} height={'24px'} visible={true} />
                  : 'Continue'
              }
            </span>
          </ButtonOptions>
        </ButtonItem>
        <Item>
          {(!user) && <div className={'login-link'}>
            <Link to={'/login'}>Return to Login</Link>
          </div>}
        </Item>
      </Form>
    </form>
  );
}

const passwordEditorOptions = { stylingMode: 'outlined', labelMode: 'floating', placeholder: 'New Password', mode: 'password' };
const confirmPasswordEditorOptions = { stylingMode: 'outlined', labelMode: 'floating', placeholder: 'Password Confirmation', mode: 'password' };
const submitButtonAttributes = { class: 'submit-button' };
